import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';

export async function addPageNumbersToPdf(input: Blob | ArrayBuffer | Uint8Array): Promise<Blob> {
    const fontSize = 10;
    const margin = 20;
    const arrayBuffer = input instanceof Blob ? await input.arrayBuffer() : input;
    const pdfDoc = await PDFDocument.load(arrayBuffer);
    const font = await pdfDoc.embedFont(StandardFonts.TimesRoman);
    const pages = pdfDoc.getPages();

    pages.forEach((page, idx) => {
        if (idx === 0) return;
        const { width } = page.getSize();
        const text = `${idx + 1}`;
        const textWidth = font.widthOfTextAtSize(text, fontSize);

        const x = (width - textWidth) / 2; // center horizontally
        const y = margin; // bottom margin

        page.drawText(text, {
            x,
            y,
            size: fontSize,
            font,
            color: rgb(0, 0, 0),
        });
    });

    const modifiedPdfBytes = await pdfDoc.save();
    const bytesView =
        modifiedPdfBytes instanceof Uint8Array
            ? modifiedPdfBytes
            : new Uint8Array(modifiedPdfBytes);
    const bytesCopy = Uint8Array.from(bytesView).buffer;
    return new Blob([bytesCopy], { type: 'application/pdf' });
}

export const blobToDataUrl = (blob: Blob): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
    });
